export const FORM_VIEW = Object.freeze({
  LOGIN: "login",
  REQUIRE_SIGNUP: "requireSignup",
  REGISTER: "register"
});

export const EMAIL_VALIDATION_PATTERN = /^([a-z0-9_+-][a-z0-9_+-.!#$%&=^`{|}~?/]*)@([a-z0-9-]+(\.[a-z0-9-]+)+)$/;
export const EMAIL_MAX_LENGTH = 128;
